import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { DateUtilities } from '@mynexus/mynexus-ui-lib';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { LEVEL_OF_CARE_LEVEL_5, LevelsOfCare } from '@shared/constants';
import { PortalProducts } from '@shared/enumeration';
import { ProviderDashboardPacServiceLine, SuggestedChangesData } from '@shared/model';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'suggested-changes-dialog',
    templateUrl: './suggested-changes-dialog.component.html',
    styleUrls: ['./suggested-changes-dialog.component.scss'],
    standalone: false
})

export class SuggestedChangesDialogComponent implements OnInit {
  levelAdjustmentForm: FormGroup;
  levelOfCare = LevelsOfCare;
  serviceLine: ProviderDashboardPacServiceLine;
  minDate: Date;
  maxDate: Date;
  levelChanges: SuggestedChangesData[];

  constructor(
    public config: DynamicDialogConfig,
    public ref: DynamicDialogRef
  ) {}

  ngOnInit(): void {
    this.serviceLine = this.config.data.selectedServiceLine;
    this.levelChanges = this.config.data.levelChanges;
    const productName = this.config.data.productName;

    if (this.serviceLine) {
      this.minDate = new Date(this.serviceLine.effectiveStartDate.replace('Z', ''));
      this.maxDate = new Date(this.serviceLine.effectiveEndDate.replace('Z', ''));
    }

    const index = this.levelOfCare.findIndex(item => item.value === LEVEL_OF_CARE_LEVEL_5);
    if (productName !== PortalProducts.PacCommercial && index !== -1) {
      this.levelOfCare.splice(index, 1);
    }

    this.createForm();
  }

  onCancel(): void {
    this.ref.close(null);
  }

  onSave(): void {
    const { levelOfCare, dateRange } = this.levelAdjustmentForm.value;

    const rangeEnd = dateRange[1] || dateRange[0];

    const requestModel: SuggestedChangesData = {
      level: levelOfCare,
      dateFrom: DateUtilities.convertToUTCStartOfDayDate(dateRange[0]).toISOString(),
      dateTo: DateUtilities.convertToUTCStartOfDayDate(rangeEnd).toISOString(),
    };

    this.ref.close(requestModel);
  }

  private createForm(): void {
    this.levelAdjustmentForm = new FormGroup({
      levelOfCare: new FormControl(null, [Validators.required]),
      dateRange: new FormControl(null, [Validators.required, this.dateOverlapValidator.bind(this)]),
    });
  }

  private dateOverlapValidator(control: FormControl): ValidationErrors | null {
    if (control?.value) {
      const start = new Date(control.value[0]);
      const end = new Date(control.value[1] || control.value[0]);

      const isOverlap = this.levelChanges.some(item => {
        const selectedStart = new Date(item.dateFrom.replace('Z', ''));
        const selectedEnd = new Date(item.dateTo.replace('Z', ''));

        return start <= selectedEnd && selectedStart <= end;
      });

      return isOverlap ? { isOverlap } : null;
    } else {
      return null;
    }

  }
}
